import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  data: any;
  status: number;
  message: string;
};

type GetDiscountBody = {
  start: number;
  length: number;
  search: string;
};

type AddDiscountBody = {
  discount_name_ar: string;
  discount_name_en: string;
  discount_name_rs: string;
  discount_percentage: number;
  description_ar: string;
  description_en: string;
  description_rs: string;
  start_date: string;
  start_time: string;
  end_date: string;
  end_time: string;
  category: number;
};

type UpdateDiscountParams = {
  body: {
    discount_name_ar: string;
    discount_name_en: string;
    discount_name_rs: string;
    discount_percentage: number;
    description_ar: string;
    description_en: string;
    description_rs: string;
    start_date: string;
    start_time: string;
    end_date: string;
    end_time: string;
    category: number;
  };
  id: string | undefined;
};

type DiscountStatusParams = {
  body: {
    is_active: any;
  };
  id: string | undefined;
};

export const discountApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addCoupon: builder.mutation<
      CommonResponseType & { data: any },
      AddDiscountBody
    >({
      query: (body) => ({
        url: END_POINTS.addCoupon,
        method: "POST",
        body,
      }),
    }),

    getCouponById: builder.query<
      CommonResponseType,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getCouponById}${id}/`,
        method: "POST",
      }),
    }),

    getCoupon: builder.mutation<CommonResponseType, GetDiscountBody>({
      query: (body) => ({
        url: END_POINTS.getAllCoupon,
        method: "POST",
        body,
      }),
    }),

    updateCoupon: builder.mutation<CommonResponseType, UpdateDiscountParams>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCoupon}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    updateCouponStatus: builder.mutation<
      CommonResponseType,
      DiscountStatusParams
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCoupon}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteCoupon: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCoupon}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddCouponMutation,
  useLazyGetCouponByIdQuery,
  useGetCouponMutation,
  useUpdateCouponMutation,
  useUpdateCouponStatusMutation,
  useDeleteCouponMutation,
} = discountApi;
